import { useEffect, useState } from 'react';

function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false);
}

/** Counts from `from` up to `value` with an ease-out curve. */
export function useAnimatedNumber(value: number, durationMs = 1200, from = 0): number {
  const [display, setDisplay] = useState(prefersReducedMotion() ? value : from);

  useEffect(() => {
    if (prefersReducedMotion() || durationMs <= 0) {
      setDisplay(value);
      return;
    }
    let frame = 0;
    const start = performance.now();
    const tick = (now: number) => {
      const t = Math.min(1, (now - start) / durationMs);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(from + (value - from) * eased);
      if (t < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [value, durationMs, from]);

  return display;
}
